import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    {...props}
  >
    <path d="M7.1978 9.67579C7.08846 9.77486 6.91117 9.77486 6.80182 9.67579L2.5778 5.84864C2.40141 5.68882 2.52634 5.41556 2.77579 5.41556L11.2238 5.41556C11.4733 5.41556 11.5982 5.68882 11.4218 5.84863L7.1978 9.67579Z" />
  </svg>
);
